export default __webpack_public_path__ + "static/media/blue3-small.02ee530b.png";